<ion-app>
  <!-- Global Language Switcher - Header Style -->

  <ion-router-outlet></ion-router-outlet>
</ion-app>